import { Button, Modal, TextField } from "@mui/material";
import { Box } from "@mui/system";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import AreaModel from "../PortSelector/models/AreaModel";
import PortMultipleSelector from "../PortSelector/PortMultipleSelector";
import { ComponentType } from "../SavedSearch/SavedSearch";
import StartEndDatepicker from "../StartEndDatepicker/StartEndDatepicker";
import DwtSelector from "../Tonnage/components/DwtSelector";
import { QueryItem } from "../Tonnage/models/TonnageQueryModel";
import { matchingPreviewSelector, setCan, setDwtMax, setDwtMin, setLay, setLoadAreas, setOpenModal, setTonnageDwt, setTriggerMatching } from "./reducers/MatchingPreviewReducer";
import "./MatchingPreview.scss";
import NumberFormatCustom from "../NumberFormatCustom/NumberFormatCustom";
import PortModel from "../PortSelector/models/PortModel";

const MatchingPreview: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const matchingPreviewData = useSelector(matchingPreviewSelector);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "800px",
        bgcolor: 'white',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const queryItemsToAeras = (queryItems: QueryItem[]) => {
        return _.map(queryItems, (queryItem) => {
            return {
                name: queryItem.value,
                positive: queryItem.positive
            } as AreaModel
        })
    }

    const areasToQueryItems = (areas: AreaModel[]) => {
        return _.map(areas, (area) => {
            return {
                id: area.name,
                value: area.name,
                positive: area.positive
            } as QueryItem
        })
    }

    return (
        <>
            <Modal
                open={matchingPreviewData.openModal && !matchingPreviewData.matchingQuery.marketingMatching}
                onClose={() => {
                    dispatch(setOpenModal(false));
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <StartEndDatepicker
                        startDateLabel={matchingPreviewData.type == ComponentType.Tonnage ? "Date2 Before" : "Can After"}
                        endDateLabel={matchingPreviewData.type == ComponentType.Tonnage ? "Date1 After" : "Lay Before"}
                        className="tonnage-search-item"
                        useQuickEndDateInput={false}
                        allowFreeInput={true}
                        startDateValue={matchingPreviewData.matchingQuery.can.toUpperCase()}
                        endDateValue={matchingPreviewData.matchingQuery.lay.toUpperCase()}
                        onStartDateChange={(date: string) => {
                            dispatch(setCan(date));
                        }}
                        onEndDateChange={(date: string) => {
                            dispatch(setLay(date));
                        }}
                    >
                    </StartEndDatepicker>
                    <PortMultipleSelector
                        portLabel='Port Open'
                        areaLabel='Area'
                        areaValues={queryItemsToAeras(matchingPreviewData.matchingQuery.loadAreas)}
                        className="tonnage-search-item"
                        onlyAreaMode={true}
                        onAreaChange={(areas: AreaModel[]) => {
                            dispatch(setLoadAreas(areasToQueryItems(areas)))
                        }}
                    >
                    </PortMultipleSelector>
                    {
                        matchingPreviewData.type == ComponentType.Tonnage &&
                        <DwtSelector
                            dwtFromValue={matchingPreviewData.matchingQuery.dwtMin}
                            dwtToValue={matchingPreviewData.matchingQuery.dwtMax}
                            className="tonnage-search-item"
                            dwtFromLabel='Dwt Min(T)'
                            dwtToLabel='Dwt Max(T)'
                            useSizeSelector={false}
                            onDwtFromChange={(value: number) => {
                                dispatch(setDwtMin(value));
                            }}
                            onDwtToChange={(value: number) => {
                                dispatch(setDwtMax(value));
                            }}
                        >
                        </DwtSelector>
                    }
                    {
                        matchingPreviewData.type == ComponentType.Cargo &&
                        <TextField
                            fullWidth
                            className="tonnage-search-item"
                            label="Tonnage Dwt(T)"
                            InputProps={{
                                inputComponent: NumberFormatCustom as any,
                            }}
                            value={matchingPreviewData.matchingQuery.tonnageDwt}
                            onChange={(event) => {
                                dispatch(setTonnageDwt(parseFloat(event.target.value)));
                            }}
                        >
                        </TextField>
                    }
                    <Button variant="outlined" color="primary"
                        onClick={() => {
                            dispatch(setOpenModal(false));
                            dispatch(setTriggerMatching((new Date()).getTime()));
                        }}
                        disabled={matchingPreviewData.type == null || matchingPreviewData.type == undefined}
                    >
                        Update
                    </Button>
                </Box>
            </Modal>
        </>
    )
};

export default MatchingPreview;